import { render, staticRenderFns } from "./redPacketRain.vue?vue&type=template&id=3a96df5a&scoped=true"
import script from "./redPacketRain.vue?vue&type=script&lang=js"
export * from "./redPacketRain.vue?vue&type=script&lang=js"
import style0 from "./redPacketRain.vue?vue&type=style&index=0&id=3a96df5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96df5a",
  null
  
)

export default component.exports